import {
  Box,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
  Grid,
  IconButton
} from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'
import useApi from '../hooks/useApi'
import moment from 'moment-timezone'
import haxios from '../lib/haxios'
import { useState } from 'react'
import NiceModal from '@ebay/nice-modal-react'

const Promotions = () => {
  const [searchValue, setSearchValue] = useState('')

  const { data: promotions, refetch } = useApi({
    url: '/promotions',
    initial: []
  })

  const promotionsFiltered = promotions
  // .filter(
  //   (el) =>
  //     el.Title.toLowerCase().includes(searchValue.toLowerCase()) &&
  //     (selectedBranch === 'ALL' || el.Branches.includes(selectedBranch)) &&
  //     (selectedRegion
  //       ? regions[selectedRegion].some((b) => el.Branches.includes(b.MamCode))
  //       : true)
  // )
  // .sort((a, b) => moment(a.ExpiryTime).isAfter(b.ExpiryTime))

  const handlePromotionModal = () => {
    NiceModal.show('promotionUploadModal', { refetch })
  }

  const handleEditModal = (p) => {
    console.log(p)
    NiceModal.show('promotionUploadModal', {
      refetch,
      defaultValues: {
        id: p._id,
        title: p.Title,
        expiryTime: moment(p.ExpiryTime).toDate(),
        pdf: p.FilePath,
        branches: p.Branches
      }
    })
  }

  const handleDelete = (p) => {
    NiceModal.show('warningModal', {
      message: `You are about to delete the promotion "${p.Title}".`,
      submit: async () => {
        await haxios.delete(`/promotions/${p._id}`)
        await refetch()
        //successToast(`Promotion deleted.`)
      }
    })
  }

  return (
    <Box sx={{
      backgroundColor: '#2C3E50',
      minHeight: '100vh',
      p: 3
    }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <TextField
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Type to search..."
            size="small"
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.5)', mr: 1 }} />
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '12px',
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&:hover fieldset': {
                  borderColor: '#FF6B35',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#FF6B35',
                },
              },
              '& .MuiInputBase-input': {
                color: 'white',
                '&::placeholder': {
                  color: 'rgba(255, 255, 255, 0.5)',
                },
              },
            }}
          />
        </Box>
        <Button
          onClick={handlePromotionModal}
          variant="contained"
          sx={{
            backgroundColor: '#FF6B35',
            color: 'white',
            fontWeight: 600,
            textTransform: 'uppercase',
            borderRadius: '12px',
            px: 3,
            py: 1,
            boxShadow: '0 2px 8px rgba(255, 107, 53, 0.3)',
            '&:hover': {
              backgroundColor: '#E55A2B',
              boxShadow: '0 4px 12px rgba(255, 107, 53, 0.4)',
            },
          }}
        >
          Add promotion
        </Button>
      </Box>

      <Grid container spacing={2}>
        {promotionsFiltered.map((p) => (
          <Grid item key={p._id}>
            <Card sx={{
              background: 'linear-gradient(135deg, #34495E 0%, #2C3E50 100%)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              borderRadius: '12px',
              overflow: 'hidden',
              width: '280px'
            }}>
              <Box sx={{ display: 'flex' }}>
                <Box
                  component="img"
                  src={p.ThumbnailPath}
                  sx={{
                    width: '120px',
                    height: '120px',
                    objectFit: 'cover'
                  }}
                />
                <CardContent sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  width: '160px'
                }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" sx={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: '14px',
                      lineHeight: 1.2,
                      mb: 1
                    }}>
                      {p.Title}
                    </Typography>
                    <Typography variant="body2" sx={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Expires
                    </Typography>
                    <Typography variant="body2" sx={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: '12px'
                    }}>
                      {moment(p.ExpiryTime).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 1,
                    mt: 2
                  }}>
                    <Button
                      size="small"
                      onClick={() => handleDelete(p)}
                      sx={{
                        backgroundColor: '#E74C3C',
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        borderRadius: '8px',
                        px: 1.5,
                        py: 0.5,
                        minWidth: 'auto',
                        '&:hover': {
                          backgroundColor: '#C0392B',
                        },
                      }}
                    >
                      Delete
                    </Button>
                    <Button
                      size="small"
                      onClick={() => handleEditModal(p)}
                      sx={{
                        backgroundColor: '#3498DB',
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        borderRadius: '8px',
                        px: 1.5,
                        py: 0.5,
                        minWidth: 'auto',
                        '&:hover': {
                          backgroundColor: '#2980B9',
                        },
                      }}
                    >
                      Edit
                    </Button>
                  </Box>
                </CardContent>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default Promotions
